import {Action, State, StateContext, Store} from '@ngxs/store';
import {Injectable, NgZone} from '@angular/core';
import {AddErrorMessage, ClearUploaded, FetchUniversities, ChangeProfileUniversity} from './university.actions';
import {UniversityService} from '../services/university.service';
import {tap} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {University} from '../models'
import {HistoryService} from "../../history/services/history.service";
import {AuthService} from "../../core/services/auth.service";


export class UniversityStateModel {
  public items: University[];
  public loading: boolean;
  public uploaded: boolean;
}


@State<UniversityStateModel>({
  name: 'university',
  defaults: {
    items: [],
    loading: false,
    uploaded: false,
  }
})
@Injectable()
export class UniversityState {

  @Action(FetchUniversities)
  fetchActions(ctx: StateContext<UniversityStateModel>, action: FetchUniversities) {
    const state = ctx.getState();
    ctx.patchState({loading: true});

    return this.universityService.fetchUniversities(action.ids, action.selections, action.allDB).pipe(
      tap((response: any) => {
        ctx.patchState({
          items: response,
          loading: false,
        });
      })
    );
  }

  @Action(AddErrorMessage)
  addErrorMessage(ctx: StateContext<UniversityStateModel>, action: AddErrorMessage) {
    ctx.patchState({uploaded: false});

    return this.universityService.addErrorMessage(action.formData).pipe(
      tap((response: any) => {
        ctx.patchState({uploaded: true});

        this.historyService.addAction({
          'text': `отправил сообщение об ошибке "${response.message}"`,
          'model': 'error-message',
          'operation': 'create',
          'object_id': response.id});
    }));
  }

  @Action(ChangeProfileUniversity)
  changeProfileUniversity(ctx: StateContext<UniversityStateModel>, action: ChangeProfileUniversity) {
    // ctx.patchState({uploaded: false});

    return this.universityService.changeProfileUniversity(action.formData).pipe(
      tap((response: any) => {

        // ctx.patchState({uploaded: true});

        this.historyService.addAction({
          'text': `изменил университет профиля на "${response.name}"`,
          'model': 'profile',
          'operation': 'update',
          'object_id': response.id});

        this.ngZone.run(() => {
            this.snackBar.open(`Университет профиля изменен на "${response.name}`, null, {
                panelClass: 'mosuir-toast',
                duration: 2500
              });
        });
        this.authService.getUser();

    }));
  }

  @Action(ClearUploaded)
  clearUploaded(ctx: StateContext<UniversityStateModel>, action: ClearUploaded) {
    ctx.patchState({uploaded: false});

  }


  constructor(private universityService: UniversityService,
              private historyService: HistoryService,
              private authService: AuthService,
              private ngZone: NgZone,
              private snackBar: MatSnackBar,
              private store: Store) {
  }

}
